<template>
	<div class="group-request" ref="reqTabs">
		<el-tabs type="card">
			<el-tab-pane :label="'待我审批(' + recvRequests.length + ')'">
				<el-scrollbar v-if="recvRequests.length" class="request-list" :style="tabPaneStyle">
					<div class="request-item" v-for="request in recvRequests" :key="request.id">
						<group-request-item :request="request"></group-request-item>
					</div>
				</el-scrollbar>
				<no-data-tip v-else class="no-data-tip" :style="tabPaneStyle" tip="暂无需要审核的申请"></no-data-tip>
			</el-tab-pane>
			<el-tab-pane :label="'我发起的(' + sendRequests.length + ')'">
				<el-scrollbar v-if="sendRequests.length" class="request-list" :style="tabPaneStyle">
					<div class="request-item" v-for="request in sendRequests" :key="request.id">
						<group-request-item :request="request"></group-request-item>
					</div>
				</el-scrollbar>
				<no-data-tip v-else class="no-data-tip" :style="tabPaneStyle" tip="您未发起群聊申请"></no-data-tip>
			</el-tab-pane>
		</el-tabs>
	</div>
</template>

<script>
import NoDataTip from '../common/NoDataTip.vue'
import GroupRequestItem from './GroupRequestItem.vue'

export default {
	name: "groupRequest",
	components: { NoDataTip, GroupRequestItem },
	data() {
		return {
			tabPaneHeight: 600
		}
	},
	computed: {
		mine() {
			return this.userStore.userInfo;
		},
		recvRequests() {
			// 我需要审批的：待处理且申请人不是我
			return this.groupRequestStore.requests.filter(req => req.status === this.$enums.REQUEST_STATUS.PENDING && req.sendId !== this.mine.id);
		},
		sendRequests() {
			// 我发起的
			return this.groupRequestStore.requests.filter(req => req.sendId === this.mine.id);
		},
		tabPaneStyle() {
			return `height:${this.tabPaneHeight}px`;
		}
	},
	mounted() {
		this.tabPaneHeight = this.$refs.reqTabs.offsetHeight - 80;
		// 每次进入刷新一次列表
		if (this.groupRequestStore && this.groupRequestStore.loadRequest) {
			this.groupRequestStore.loadRequest();
		}
	}
}
</script>

<style scoped lang="scss">
.group-request {
	display: flex;
	flex-direction: column;

	.request-list {
		padding: 8px 12px;
	}
}
</style>

